/**
 * Given a link, determine if it is actually enabled
 * @param {Object} param0 Link object
 * @returns {Boolean} isEnabled
 */
function checkLinkEnabled(_ref) {
  let {
    enabled,
    label,
    type,
    url,
    banners,
    text_options,
    group_options
  } = _ref;
  let isEnabled = enabled && label;
  if ((type === 'link' || !type) && !url) isEnabled = false;
  if (type === 'carousel') isEnabled = banners && banners.length && enabled;
  if (type === 'feed' || type === 'form' || type === 'image-grid') isEnabled = enabled;
  if (type === 'embed') isEnabled = enabled && url;
  if (type === 'text') isEnabled = enabled && text_options.text;
  if (type === 'group') isEnabled = enabled && label && group_options.number_of_enabled_links;
  return isEnabled;
}
export { checkLinkEnabled };